import { render, staticRenderFns } from "./LayerLegendComponent.vue.js?vue&type=template&id=4bf3ca60&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=template&id=4bf3ca60&scoped=true"
import script from "./LayerLegendComponent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=script&lang=js"
export * from "./LayerLegendComponent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3ca60",
  null
  
)

export default component.exports